export const defaultJsonSerializer = JSON;